<template>
    <div @drop="onDrop($event)" @dragover.prevent @dragenter.prevent
        class="container-dropper justify-content-center align-items-center">
        <template v-if="sortedMappingComponents.length">
            <div class="pl-4" v-for="(layout, idx_layout) in sortedMappingComponents" :key="idx_layout">
                <b-row @dragstart="startDragOrderLayout($event, idx_layout)" draggable
                    @drop="onDropAdjustOrderLayout($event, idx_layout)" @dragover.prevent @dragenter.prevent
                    class="cursor-pointer pl-4 mt-3 p-3 d-flex w-100 bg-white border" v-if="layout.type === 'layout'">
                    <template v-for="(column, idx_column) in layout.column">
                        <b-col :key="idx_column" class="layout-box bg-white border bg-warning" :md="column">
                            <div @drop="onDrop($event, layout.id, (idx_column + 1))" @dragover.prevent
                                @dragenter.prevent style="min-height: 60px" class="w-100 p-2">
                                <div v-if="!layout.content[`container_${idx_column + 1}`].length"
                                    style="border: 1px dashed #e6e6e6;"
                                    class="p-3 w-100 h-100 d-flex justify-content-center align-items-center">
                                    <i style="color: #d1d1d1; font-size: 30px; " class="mdi mdi-text-box-multiple" />
                                </div>
                                <div v-else class="w-100">
                                    <div v-for="(element, idx_element) in layout.content[`container_${idx_column + 1}`]"
                                        :key="idx_element" class="cursor-pointer p-2 mt-2"
                                        style="width: 100%; overflow-x: auto;" :style="{
                                            border: `1px solid ${selectedElement.id === element.id ? 'green' : '#e9ebf2'}`,
                                        }" @click="onSelectElement(element, idx_layout, idx_column, idx_element)">
                                        <div @dragstart="startDragOrderElement($event, idx_layout, (idx_column + 1), idx_element)"
                                            draggable
                                            @drop="onDropAdjustOrderElement($event, idx_layout, (idx_column + 1), idx_element)"
                                            @dragover.prevent @dragenter.prevent class="w-100">
                                            <div :class="[element.status !== 'edit' && 'd-flex', !element.status && !element.text ? ' justify-content-end' : 'justify-content-between']"
                                                v-if="element.category === 'font'">
                                                <template>
                                                    <quill-editor v-if="element.status === 'edit'"
                                                        v-model="element.text" :options="editorOptions"
                                                        @change="onChangeConvertHtmlElements(element.id, element.category, layout.id, idx_column + 1, element.text)"
                                                        @keydown.native="handlerInputBodyContent($event, idx_layout, idx_column, idx_element)"
                                                        ref="quillEditor" class="wysiwyg-editor" />
                                                    <div :class="[
                                                        'd-flex justify-content-start text-left',
                                                        selectedElement.id === element.id ? 'w-90' : 'w-100'
                                                    ]" v-else>
                                                      <iframe
                                                      v-if="element.text"
                                                      :srcdoc="generateIframeHtml(element.text)"
                                                      class="w-90"
                                                      style="word-wrap: break-word; white-space: normal; border: none; pointer-events: none;"
                                                      ></iframe>
                                                      <div v-else>
                                                          <p>Type here and customize font and color...</p>
                                                      </div>
                                                    </div>
                                                </template>
                                                <div v-if="selectedElement.id === element.id"
                                                    :class="['d-flex justify-content-end', element.status === 'edit' ? 'w-100' : 'w-10']">
                                                    <div>
                                                        <template>
                                                            <el-tooltip v-if="element.status === 'edit'"
                                                                class="item m-1" effect="dark" content="Add Variable"
                                                                placement="top">
                                                                <button
                                                                    @click="addVariableBody(idx_layout, idx_column, idx_element)"
                                                                    class="btn btn-outline-secondary mr-1 btn-xs mt-2 p-1">
                                                                    <font-awesome icon="plus" />
                                                                </button>
                                                            </el-tooltip>
                                                            <el-tooltip v-else class="item m-1" effect="dark"
                                                                content="Edit" placement="top">
                                                                <button
                                                                    @click="editBoxElements(idx_layout, idx_column, idx_element)"
                                                                    class="btn btn-outline-primary mr-1 btn-xs mt-2 p-1">
                                                                    <font-awesome icon="pen" />
                                                                </button>
                                                            </el-tooltip>
                                                        </template>
                                                        <el-tooltip class="item m-1" effect="dark" content="Delete"
                                                            placement="top">
                                                            <button
                                                                @click="deleteBoxElements(idx_layout, idx_column, idx_element, element_id)"
                                                                class="btn btn-outline-danger btn-xs mt-2 p-1">
                                                                <font-awesome icon="trash" />
                                                            </button>
                                                        </el-tooltip>
                                                        <el-tooltip v-if="element.status === 'edit'" class="item m-1"
                                                            effect="dark" content="Save" placement="top">
                                                            <button
                                                                @click="saveBoxElements(idx_layout, idx_column, idx_element)"
                                                                class="btn btn-outline-primary mr-1 btn-xs mt-2 p-1">
                                                                <!-- <font-awesome icon="save"/> -->
                                                                Save
                                                            </button>
                                                        </el-tooltip>
                                                    </div>
                                                </div>
                                            </div>
                                            <div :class="[element.status !== 'edit' && 'd-flex', !element.status && !element.text ? ' justify-content-end' : 'justify-content-between']"
                                                v-else-if="element.category === 'button'">
                                                <el-input v-if="element.status === 'edit'" class="mt-3 w-100"
                                                    @keydown.native="handlerInputBodyContent($event, idx_layout, idx_column, idx_element)"
                                                    v-model="element.text"
                                                    @input="onChangeConvertHtmlElements(element.id, element.category, layout.id, (idx_column + 1), element.text)"
                                                    type="name" />
                                                <div v-else
                                                    :class="['w-100 d-flex', `justify-content-${element.align}`]">
                                                    <a :style="{
                                                        wordWrap: 'break-word',
                                                        whiteSpace: 'normal',
                                                        width: 'auto',
                                                        backgroundColor: element.background === 'color' ? element.color : 'transparent',
                                                        color: element.background === 'color' ? '#fff' : element.color,
                                                        border: element.background === 'transparent' ? 'none' : '1px solid #ccc',
                                                        borderRadius: '5px',
                                                        padding: '10px',
                                                    }" :class="[element.container_style === 'full_width' && 'w-100 text-center']">
                                                        {{ element.text }}
                                                    </a>
                                                </div>
                                                <div v-if="selectedElement.id === element.id"
                                                    :class="['d-flex justify-content-end', element.status !== 'edit' && 'h-100']">
                                                    <template>
                                                        <el-tooltip v-if="element.status === 'edit'" class="item m-1"
                                                            effect="dark" content="Add Variable" placement="top">
                                                            <button
                                                                @click="addVariableBody(idx_layout, idx_column, idx_element)"
                                                                class="btn btn-outline-secondary mr-1 btn-xs mt-2 p-1">
                                                                <font-awesome icon="plus" />
                                                            </button>
                                                        </el-tooltip>
                                                        <el-tooltip v-else class="item m-1" effect="dark" content="Edit"
                                                            placement="top">
                                                            <button
                                                                @click="editBoxElements(idx_layout, idx_column, idx_element)"
                                                                class="btn btn-outline-primary mr-1 btn-xs mt-2 p-1">
                                                                <font-awesome icon="pen" />
                                                            </button>
                                                        </el-tooltip>
                                                    </template>
                                                    <el-tooltip class="item m-1" effect="dark" content="Delete"
                                                        placement="top">
                                                        <button
                                                            @click="deleteBoxElements(idx_layout, idx_column, idx_element, element_id)"
                                                            class="btn btn-outline-danger btn-xs mt-2 p-1">
                                                            <font-awesome icon="trash" />
                                                        </button>
                                                    </el-tooltip>
                                                    <el-tooltip v-if="element.status === 'edit'" class="item m-1"
                                                        effect="dark" content="Save" placement="top">
                                                        <button
                                                            :disabled="!element?.text || !element.text.trim().length"
                                                            @click="saveBoxElements(idx_layout, idx_column, idx_element)"
                                                            class="btn btn-outline-primary mr-1 btn-xs mt-2 p-1">
                                                            Save
                                                        </button>
                                                    </el-tooltip>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between w-100"
                                                v-else-if="element.category === 'image'">
                                                <div
                                                    :class="[`d-flex justify-content-${element.align} align-items-center flex-grow-1`]">
                                                    <img class="template-img" v-if="!element.status"
                                                        :src=defaultImage />
                                                </div>
                                                <div v-if="selectedElement.id === element.id" class="ml-2 h-100">
                                                    <el-tooltip class="item m-1" effect="dark" content="Delete"
                                                        placement="top">
                                                        <button
                                                            @click="deleteBoxElements(idx_layout, idx_column, idx_element, element_id)"
                                                            class="btn btn-outline-danger btn-xs p-1">
                                                            <font-awesome icon="trash" />
                                                        </button>
                                                    </el-tooltip>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between"
                                                v-else-if="element.category === 'divider'">
                                                <div :style="{
                                                    width: element.width + '%',
                                                    borderBottom: element.weight + 'px ' + element.style + ' ' + element.color,
                                                    margin: '1rem 0'
                                                }" />
                                                <div v-if="selectedElement.id === element.id">
                                                    <el-tooltip class="item m-1" effect="dark" content="Delete"
                                                        placement="top">
                                                        <button
                                                            @click="deleteBoxElements(idx_layout, idx_column, idx_element, element_id)"
                                                            class="btn btn-outline-danger ml-2 btn-xs mt-2 p-1">
                                                            <font-awesome icon="trash" />
                                                        </button>
                                                    </el-tooltip>
                                                </div>
                                            </div>
                                            <div style="height: 35px" v-else-if="element.category === 'spacer'">
                                                <!-- <br /> -->
                                                <div class="d-flex w-100 justify-content-end "
                                                    v-if="selectedElement.id === element.id">
                                                    <el-tooltip class="item" effect="dark" content="Delete"
                                                        placement="top">
                                                        <button
                                                            @click="deleteBoxElements(idx_layout, idx_column, idx_element, element_id)"
                                                            class="btn btn-outline-danger btn-xs mt-2 p-1">
                                                            <font-awesome icon="trash" />
                                                        </button>
                                                    </el-tooltip>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </template>
                    <div class="d-flex w-100 justify-content-end mt-2">
                        <el-tooltip class="item m-1" effect="dark" content="Delete" placement="top">
                            <button @click="deleteBoxLayout(idx_layout)" class="btn btn-outline-danger btn-xs mt-2 p-1">
                                <font-awesome icon="trash" />
                            </button>
                        </el-tooltip>
                    </div>
                </b-row>
            </div>
        </template>
    </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.snow.css';

export default {
  name: 'DroppingItemEmail',
  components: {
    quillEditor,
  },
  props: {
    sortedMappingComponents: {
      type: Array,
      required: true,
    },
    selectedElement: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editorOptions: {
        theme: 'snow',
        placeholder: 'Write your text here...',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            ['link'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            // [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }],
            [{ align: [] }],
          ],
        },
      },
    };
  },
  computed: {
    defaultImage() {
      return 'https://media.wappin.chat/template-header-image.png';
    },
  },
  methods: {
    onDrop(evt, layout_id, column_number) {
      this.$emit('onDrop', evt, layout_id, column_number);
    },
    startDragOrderLayout(evt, idx_layout) {
      this.$emit('startDragOrderLayout', evt, idx_layout);
    },
    onDropAdjustOrderLayout(evt, idx_layout) {
      this.$emit('onDropAdjustOrderLayout', evt, idx_layout);
    },
    startDragOrderElement(evt, idx_layout, column_number, idx_element) {
      this.$emit('startDragOrderElement', evt, idx_layout, column_number, idx_element);
    },
    onDropAdjustOrderElement(evt, idx_layout, column_number, idx_element) {
      this.$emit('onDropAdjustOrderElement', evt, idx_layout, column_number, idx_element);
    },
    saveBoxElements(layout_index, column_index, element_index) {
      this.$emit('saveBoxElements', layout_index, column_index, element_index);
    },
    editBoxElements(layout_index, column_index, element_index) {
      this.$emit('editBoxElements', layout_index, column_index, element_index);
    },
    deleteBoxElements(layout_index, column_index, element_index) {
      this.$emit('deleteBoxElements', layout_index, column_index, element_index);
    },
    deleteBoxLayout(layout_index) {
      this.$emit('deleteBoxLayout', layout_index);
    },
    onChangeConvertHtmlElements(id, category, layout_id, column_number, text) {
      this.$emit('onChangeConvertHtmlElements', id, category, layout_id, column_number, text);
    },
    handlerInputBodyContent(event, layout_index, container_index, element_index) {
      this.$emit('handlerInputBodyContent', event, layout_index, container_index, element_index);
    },
    addVariableBody(layoutIndex, containerIndex, elementIndex) {
      this.$emit('addVariableBody', layoutIndex, containerIndex, elementIndex);
    },
    onSelectElement(el, idx_layout, idx_column, idx_element) {
      this.$emit('onSelectElement', el, idx_layout, idx_column, idx_element);
    },
    convertQuillHyperLink(text) {
      this.$emit('convertQuillHyperLink', text);
    },
    convertQuillSizes(text) {
      this.$emit('convertQuillSizes', text);
    },
    convertQuillAlign(text) {
      this.$emit('convertQuillAlign', text);
    },
    generateIframeHtml(content) {
      return `
        <html>
            <head>
                <style type="text/css" id="responsive-stack-styles">
                    .ql-size-small { font-size: 0.75em; }
                    .ql-size-large { font-size: 1.5em; }
                    .ql-size-huge { font-size: 2.5em; }
                    
                    /* Removed quotes from the values below */
                    .ql-align-center { text-align: center; }
                    .ql-align-left { text-align: left; }
                    .ql-align-right { text-align: right; }
                </style>
            </head>
            <body>${content}</body>
        </html>
        `;
    },
  },
};
</script>

<style>
.wysiwyg-editor {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

.wysiwyg-editor .ql-container {
  height: 200px !important;
}

.wysiwyg-editor .ql-editor {
  overflow-x: auto !important;
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
}

.container-dropper {
  height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.layout-box {
  padding: 10px;
  width: 100%;
  min-height: 80px;
  display: flex;
  /* justify-content: center; */
  /* align-items: center; */
  /* text-align: center; */
}
</style>
